import {
  call,
  put,
  takeLatest,
} from 'redux-saga/effects';

import getRoleAPI from '../../api/get-role';
import { getRoleReceive, getRoleReject, getRoleRequested } from '../actions/admin-page';

interface IGetRoleAction {
  type: string;
  payload: {
    search: string
  }

}

interface IRoleResponse {
  role: {
    id: string,
    title: string
  }[]
}

const getRole = function* getRole(action: IGetRoleAction) {
  try {
    const response: IRoleResponse = yield call(getRoleAPI, action.payload.search);
    yield put(getRoleReceive({ role: response }));
  } catch (error) {
    yield put(getRoleReject({ error }));
  }
};

export default function* getRoleWatcher() {
  yield takeLatest(getRoleRequested, getRole);
}
